export const DEFAULT_REMINDER_OFFSET_IN_MINUTES = 1440;
export const DEFAULT_SEND_OPTION = 'Customer';
export const DEFAULT_REMINDER_MESSAGE = '';
export const DEFAULT_REMINDER_OFFSET = 10080;
export const DEFAULT_REMINDER_ID = 'DefaultReminderId';

export const DEFAULT_FOLLOW_UP_OFFSET = -15;
export const DEFAULT_FOLLOW_UP_ID = 'DefaultFollowUpId';
